import { useEffect, useState } from "react";
import { parseISO, isBefore, startOfMonth, endOfMonth, format } from 'date-fns';
import DateInput from "./InputDate";
import TimeInput from "./InputTime";

const FlowMeasurementChoice = ({
    setDateTimeFrom,
    setDateTimeTo,
    disabled = false
}) => {
    
    // CURRENT MONTH 
    const firstDay = startOfMonth(new Date());
    const formattedFirstDay = format(firstDay, 'yyyy-MM-dd');
    const lastDay = endOfMonth(new Date());
    const formattedLastDay = format(lastDay, 'yyyy-MM-dd');

    const [selectedFromDate, setSelectedFromDate] = useState(formattedFirstDay);
    const [selectedFromTime, setSelectedFromTime] = useState('00:00:00');
    const [selectedToDate, setSelectedToDate] = useState(formattedLastDay);
    const [selectedToTime, setSelectedToTime] = useState('23:59:59');
    
    const handleChangeFromDate = (event) => {
        setSelectedFromDate(event.target.value);
    };
    const handleChangeFromTime = (event) => {
        setSelectedFromTime(event.target.value);
    };
    const handleChangeToDate = (event) => {
        setSelectedToDate(event.target.value);
    };
    const handleChangeToTime = (event) => {
        setSelectedToTime(event.target.value);
    };

    useEffect(() => {
        setDateTimeFrom(`${selectedFromDate}T${selectedFromTime}`)
    }, [selectedFromDate, selectedFromTime])

    useEffect(() => {
        setDateTimeTo(`${selectedToDate}T${selectedToTime}`)
    }, [selectedToDate, selectedToTime])

    return (
        <div className="flow-measurement-choice-card">
            <h4>Flow Measurement</h4>
            <div className="flow-measurement-choice-input-group">
                <label
                    htmlFor=''
                    className='bold-label'
                >
                    FROM:
                </label>
                <div>
                    <DateInput 
                        selectedDate={selectedFromDate}
                        handleSelectedDate={handleChangeFromDate}
                        disabled={disabled}
                    />
                    <TimeInput 
                        selectedTime={selectedFromTime}
                        handleSelectedTime={handleChangeFromTime}
                        disabled={disabled}
                    />    
                </div>
            </div>
            <div className="flow-measurement-choice-input-group">
                <label
                    htmlFor=''
                    className='bold-label'
                >
                    TO:
                </label>
                <div className="choice-date-time-group">
                    <DateInput 
                        selectedDate={selectedToDate}
                        handleSelectedDate={handleChangeToDate}
                        disabled={disabled}
                    />
                    <TimeInput 
                        selectedTime={selectedToTime}
                        handleSelectedTime={handleChangeToTime}
                        disabled={disabled}
                    />
                </div>
            </div>
        </div>
    )
}

export default FlowMeasurementChoice;